/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IVisitable } from '../IVisitable';

/**
 * Any node model that represents an example.  This exists because the models for the
 * OpenAPI 2 and OpenAPI 3 example nodes are mutually exclusive.
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IExample extends IVisitable {}


